import React from "react";
import { usePopper } from 'react-popper';
import { UserIcon, ConfigIcon, ExitIcon } from "../../assets/icons";
import {Link} from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { Image } from 'antd';
import RequestApi from "../../api/RequestApi";

const ProfileBox = () => {

    const {roles, user} = useAuth();
    const [avatar, setAvatar] = React.useState(null);
    const [referenceElement, setReferenceElement] = React.useState(null);
    const [popperElement, setPopperElement] = React.useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement: "right-end",
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [0, 12],
                },
            },
        ]
    });
    const [isOpen, setIsOpen] = React.useState(false);

    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.composedPath().includes(popperElement) && !event.composedPath().includes(referenceElement)) {
                setIsOpen(false);
            }
        }
        document.body.addEventListener('click', handleClickOutside);
        return () => {
            document.body.removeEventListener('click', handleClickOutside);
        }

    }, [referenceElement, popperElement])

    React.useEffect(() => {
        RequestApi.get('private/user-avatar/' + user.id).then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS) {
                setAvatar(data.url);
            }
        })
    }, [])

    return (
        <div id="profile-wrapper" className="flex">
            <button id="profile-ref" onClick={() => setIsOpen(!isOpen)} className="avatar h-12 w-12" ref={setReferenceElement}>
                {
                    avatar &&
                    <img
                        className="rounded-full"
                        src={avatar}
                        alt="avatar"
                    />
                }
                {
                    !avatar &&
                    <img
                        className="rounded-full"
                        src="/images/100x100.png"
                        alt="avatar"
                    />
                }
                <span
                    className="absolute right-0 h-3.5 w-3.5 rounded-full border-2 border-white bg-success dark:border-navy-700"
                ></span>
            </button>
            <div id="profile-box" ref={setPopperElement} className={isOpen ? "popper-root fixed show" : "popper-root fixed"} style={styles.popper} {...attributes.popper}>
                <div className="popper-box w-64 rounded-lg border border-slate-150 bg-white shadow-soft dark:border-navy-600 dark:bg-navy-700">
                    <div className="flex items-center space-x-4 rounded-t-lg bg-slate-100 px-4 py-5 dark:bg-navy-800">
                        <div className="avatar h-14 w-14">
                            {
                                avatar &&
                                <Image
                                    className="rounded-full"
                                    src={avatar}
                                    preview={{
                                        mask: <span></span>,
                                        maskClassName: 'hover-user-avatar',
                                        src: avatar.replace("_100", "_orig"),
                                    }}
                                />
                            }
                            {
                                !avatar &&
                                <img
                                    className="rounded-full"
                                    src="/images/100x100.png"
                                    alt="avatar"
                                />
                            }
                        </div>
                        <div>
                            <a href="#" className="text-base font-medium text-slate-700 hover:text-primary focus:text-primary dark:text-navy-100 dark:hover:text-accent-light dark:focus:text-accent-light">
                                { user.name ? user.name :  user.login }
                            </a>
                            <p className="text-xs text-slate-400 dark:text-navy-300">
                                { roles.includes('ROLE_ADMIN') && 'Администратор'}
                                { roles.includes('ROLE_MANAGER') && 'Менеджер'}
                                { roles.includes('ROLE_PARTNER') && 'Партнер'}
                                {
                                    !roles.includes('ROLE_ADMIN') && !roles.includes('ROLE_MANAGER') && !roles.includes('ROLE_PARTNER')
                                    && 'Клиент'
                                }
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col pb-5 pt-2">
                        <Link onClick={() => setIsOpen(!isOpen)} to="/cabinet/profile" className="group flex items-center space-x-3 px-4 py-2 tracking-wide outline-none transition-all hover:bg-slate-100 focus:bg-slate-100 dark:hover:bg-navy-600 dark:focus:bg-navy-600">
                            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-warning text-white">
                                <UserIcon />
                            </div>

                            <div>
                                <h2 className="font-medium text-slate-700 transition-colors group-hover:text-primary group-focus:text-primary dark:text-navy-100 dark:group-hover:text-accent-light dark:group-focus:text-accent-light">
                                    Профиль
                                </h2>
                                <div className="line-clamp-1 text-xs text-slate-400 dark:text-navy-300">
                                    Личные данные
                                </div>
                            </div>
                        </Link>
                        {/*<a href="#" className="group flex items-center space-x-3 px-4 py-2 tracking-wide outline-none transition-all hover:bg-slate-100 focus:bg-slate-100 dark:hover:bg-navy-600 dark:focus:bg-navy-600">
                            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-success text-white">
                                <ConfigIcon />
                            </div>

                            <div>
                                <h2 className="font-medium text-slate-700 transition-colors group-hover:text-primary group-focus:text-primary dark:text-navy-100 dark:group-hover:text-accent-light dark:group-focus:text-accent-light">
                                    Настройки
                                </h2>
                                <div className="line-clamp-1 text-xs text-slate-400 dark:text-navy-300">
                                    Основные настройки
                                </div>
                            </div>
                        </a>*/}
                        <div className="mt-3 px-4">
                            <Link to="/logout" className="btn h-9 w-full space-x-2 bg-primary text-white hover:bg-primary-focus focus:bg-primary-focus active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:focus:bg-accent-focus dark:active:bg-accent/90">
                                <ExitIcon />
                                <span>Выход</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default ProfileBox;
